import React, { useEffect, useState } from 'react';
import { getMsalInstance, loginRequest } from '../../config/msal-config';
import { mainServices } from '../../services/main';
import { setLocalStorage } from '../../utils/common.util';

const RedirectSSO = () => {
  const [ssoResponse, setSSOResponse] = useState(null);

  const hostname = window.location.hostname;
  const tenant =
    hostname.split('.')[0] === 'localhost'
      ? process.env.REACT_APP_LOCALHOST_CLIENT_ID
      : hostname.split('.')[0];

  useEffect(() => {
    const handleRedirectResponse = async () => {
      const msalInstance = getMsalInstance();
      try {
        const response = await msalInstance.handleRedirectPromise();
        if (response) {
          setSSOResponse(response);
          setLocalStorage('MSSO', response);
        } else {
          const accounts = msalInstance.getAllAccounts();
          if (accounts.length > 0) {
            const tokenResponse = await msalInstance.acquireTokenSilent({
              account: accounts[0],
              ...loginRequest,
            });
            setSSOResponse(tokenResponse);
            setLocalStorage('MSSO', tokenResponse);
          } else {
            console.error('No response or accounts found.');
            await msalInstance.loginRedirect();
          }
        }
      } catch (error) {
        console.error('SSO Error:', error);
        await msalInstance.loginRedirect();
      }
    };

    handleRedirectResponse();
  }, []);

  useEffect(async () => {
    if (ssoResponse) {
      const response = await new mainServices().redirectSSO({
        client_id: tenant,
        email: ssoResponse?.account?.username,
      });
      window.location.href = response.data.data.redirectionUrl;
    }
  }, [ssoResponse]);

  return (
    <div style={{ padding: '2rem' }}>
      <h2>SSO Redirect Handling</h2>
      <p>Waiting for SSO response...</p>
    </div>
  );
};

export default RedirectSSO;
